<ng-container data-testid="flight-selection-filters" *ngIf="showFlightSelectionFilters">
  @let isMobile = isMobile$ | async;
  <div class="flex flex--middle flex--wrap" [ngClass]="{ 'pr-xsmall-t': isMobile !== true }">
    <button
      *ngIf="isMobile === false && (selectedFiltersLength$ | async) > 0"
      (click)="clearAllFilters('master-reset')"
      class="flex flex--middle"
      data-testid="master-reset-button"
    >
      <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.UPDATE" />
      <span class="ms-xxsmall-l ms-small-r font-body-1 bold-type">{{
        'flightFilters.resetFilters' | finLocalization
      }}</span>
    </button>
    <fcom-checkbox-input
      *ngIf="isMobile === false"
      data-testid="direct-flights-shortcut"
      [parentForm]="filtersForm"
      [controlName]="'directFlight'"
      [translationPrefix]="'flightFilters.stopsCountB.direct'"
    >
      <span class="font-body-1 medium-type font-body-medium">
        {{ 'flightFilters.stopsCountB.direct' | finLocalization }}
        <span *ngIf="(boundsHasDirectFlights$ | async) === false || (allBoundsAreDirect$ | async)">
          ({{ amountOfDirectFlights$ | async }})</span
        >
      </span>
    </fcom-checkbox-input>
    <ng-template #flightFiltersContent>
      <div
        class="ms-large ps-large-b border-bottom"
        [ngClass]="{
          'ms-xxlarge-x': isMobile === false,
        }"
      >
        <div class="nordic-blue-900-text font-body-1 medium-type ms-medium-b text-icon-primary font-body-medium">
          {{ 'flightFilters.stopsCount.title' | finLocalization }}
        </div>
        <fcom-radio-item-group
          [options]="[
            {
              label: 'flightFilters.stopsCount.all',
              value: null,
              disabled: (allBoundsAreDirect$ | async),
            },
            {
              label: 'flightFilters.stopsCountB.stops',
              value: '1',
              disabled: (allBoundsAreDirect$ | async),
            },
            {
              label: 'flightFilters.stopsCountB.direct',
              value: '0',
              labelText:
                (allBoundsAreDirect$ | async) || (boundsHasDirectFlights$ | async) === false
                  ? ('flightFilters.stopsCountB.directWithAmount'
                    | finLocalization: { amount: amountOfDirectFlights$ | async })
                  : null,
              disabled: (boundsHasDirectFlights$ | async) === false || (allBoundsAreDirect$ | async),
            },
          ]"
          [parentForm]="filtersForm"
          [controlName]="'stopsCount'"
          [translationPrefix]="'flightFilters.stopsCount'"
          [titleText]="false"
          data-testid="stops-filter"
        />
      </div>

      <ng-template #travelClass>
        <div
          class="ms-large ps-large-b"
          [ngClass]="{
            'ms-xxlarge-x': isMobile === false,
          }"
        >
          <div class="nordic-blue-900-text font-body-1 medium-type ms-medium-b text-icon-primary font-body-medium">
            {{ 'flightFilters.travelClass.title' | finLocalization }}
          </div>
          <fcom-radio-item-group
            [options]="travelClassFilters"
            [parentForm]="filtersForm"
            [controlName]="'cabin'"
            [translationPrefix]="'flightFilters.travelClass'"
            [titleText]="false"
            data-testid="travel-class-filter"
          />
        </div>
      </ng-template>

      @if (isMobile === false) {
        <div class="ms-large-y ms-xxlarge-x border-bottom">
          <div class="flex">
            <div class="flex--basis-half">
              <ng-container *ngTemplateOutlet="departureTime" />
            </div>
            <div class="flex--basis-half"><ng-container *ngTemplateOutlet="arrivalTime" /></div>
          </div>
        </div>
      } @else {
        <div class="ms-large border-bottom">
          <ng-container *ngTemplateOutlet="departureTime" />
        </div>
        <div class="ms-large border-bottom">
          <ng-container *ngTemplateOutlet="arrivalTime" />
        </div>
      }

      <ng-container [ngTemplateOutlet]="travelClass" />

      <ng-template #departureTime>
        <div class="flex flex--column">
          <span class="nordic-blue-900-text font-body-1 medium-type ps-xsmall-b text-icon-primary font-body-medium">{{
            'flightFilters.times.departure.title' | finLocalization
          }}</span>
          <span class="font-body-1">
            {{ 'flightFilters.times.departure.from' | finLocalization }}
            <b>{{ departureCityName }}</b>
          </span>
        </div>

        <div class="flex flex--column ms-medium-t">
          <ng-container *ngFor="let departureTime of FlightTimeOption | keyvalue: keepOrder">
            <fcom-checkbox-input
              class="ms-large-b"
              [parentForm]="filtersForm"
              [controlName]="'departure' + departureTime.key"
            >
              <div class="flex flex--column">
                <span class="font-body-1 medium-type font-body-medium">
                  {{ 'flightFilters.times.departure.' + departureTime.key.toLowerCase() | finLocalization }}
                </span>
                <span class="font-body-1 light-type ms-xxsmall-t font-body-medium">{{
                  getTimeRange(departureTime.value)
                }}</span>
              </div>
            </fcom-checkbox-input>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #arrivalTime>
        <div class="flex flex--column">
          <span class="nordic-blue-900-text font-body-1 font-body-medium medium-type ps-xsmall-b">{{
            'flightFilters.times.arrival.title' | finLocalization
          }}</span>
          <span class="font-body-1 font-body-medium">
            {{ 'flightFilters.times.arrival.landing' | finLocalization }}
            <b>{{ arrivalCityName }}</b></span
          >
        </div>
        <div class="flex flex--column ms-medium-t">
          <ng-container *ngFor="let arrivalTime of FlightTimeOption | keyvalue: keepOrder">
            <fcom-checkbox-input
              class="ms-large-b"
              [parentForm]="filtersForm"
              [controlName]="'arrival' + arrivalTime.key"
            >
              <div class="flex flex--column">
                <span class="font-body-1 font-body-medium medium-type">
                  {{ 'flightFilters.times.arrival.' + arrivalTime.key.toLowerCase() | finLocalization }}
                </span>
                <span class="font-body-2 light-type ms-xxsmall-t font-body-small">{{
                  getTimeRange(arrivalTime.value)
                }}</span>
              </div>
            </fcom-checkbox-input>
          </ng-container>
        </div>
      </ng-template>

      <div *ngIf="showRefundability" class="ms-large ps-large-b">
        <div class="nordic-blue-900-text font-body-1 font-body-medium text-icon-primary medium-type ms-medium-b">
          {{ 'flightFilters.refundability.title' | finLocalization }}
        </div>
        <fcom-radio-item-group
          [options]="[
            { label: 'flightFilters.refundability.anyTicketType', value: 'false' },
            { label: 'flightFilters.refundability.onlyRefundable', value: 'true' },
          ]"
          [parentForm]="filtersForm"
          [controlName]="'refundable'"
          [translationPrefix]="'flightFilters.refundability'"
          [titleText]="false"
        />
      </div>
    </ng-template>
    <fcom-filters
      class="flex-1"
      *ngIf="travelClasses$ | async as availableCabinClasses"
      data-testid="mobile-filters"
      [modalInDesktop]="true"
      [isModalOpen]="isModalOpen"
      [hasFiltering]="(selectedFiltersLength$ | async) > 0"
      [buttonText]="(isMobile === false ? 'flightFilters.titleDesktop' : 'flightFilters.title') | finLocalization"
      [modalTitle]="'flightFilters.modalTitle' | finLocalization"
      [notificationContent]="'flightFilters.modalNotification' | finLocalization"
      [numberToShowWhenFiltered]="selectedFiltersLength$ | async"
      [displayNotification]="resultsAmount === 0"
      [primaryFooterButtonTitle]="'flightFilters.action.showResults' | finLocalization: { flights: resultsAmount }"
      (primaryFooterButtonClick)="updateNextFiltersToStore()"
      [secondaryFooterButtonTitle]="'flightFilters.action.reset' | finLocalization"
      (secondaryFooterButtonClick)="clearAllFilters(isMobile ? 'mobile' : 'desktop')"
      (filtersOpen)="showModal()"
      (filtersClose)="closeModal()"
      [filterContent]="flightFiltersContent"
    ></fcom-filters>
  </div>
</ng-container>
